export const STORY_FORM_CONSTS = {
  addAtLeastOnePublication: 'Добавьте хотя бы одну публикацию, чтобы сюжет стал виден на сайте',
  alreadyAdded: 'Публикация уже добавлена в сюжет',
  changesNeeded: 'Для сохранения сюжета нужно внести какие-нибудь изменения',
  deletePublicationConfirmationText: 'удалить публикацию из сюжета?',
  deletePublicationConfirmationFirstSentenceText: 'Вы уверены, что хотите',
  deletePublicationConfirmBtn: 'Да, удалить',
  description: 'описание',
  itNecessaryToFill: 'Необходимо заполнить: ',
  publicationsNotExists: 'Публикации отсутствуют',
  incutsNotExists: 'Врезки отсутствуют',
  thereAreProblems: 'Есть проблемы: ',
  publicStories: 'Публикации',
  incutsStories: 'Врезки',
  title: 'название',
  saved: 'Сохранено',
  storyPhoto: 'фото для сюжета',
  storyEditing: 'Редактирование сюжета',
  storyView: 'Просмотр сюжета',
  successAdded: 'Публикация добавлена успешно',
  successDeleted: 'Публикация удалена успешно',
  figureVersion: {
    id: '',
    uid: '',
    crop: {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      __typename: 'Crop'
    },
    figure: {
      id: '',
      uid: '',
      src: '',
      alt: '',
      author: '',
      description: '',
      createdAt: '',
      updatedAt: '',
      hasWatermark: false,
      hasDiagonalWatermark: false,
      type: {
        id: '',
        uid: '',
        slug: '',
        __typename: 'FigureType'
      },
      cropperPreview: {
        url: '',
        __typename: 'Image'
      },
      sourceImage: {
        url: '',
        __typename: 'Image'
      },
      __typename: 'Figure'
    },
    primaryProcessedImage: {
      url: '',
      __typename: 'Image'
    },
    processedImages: [
      {
        code: '',
        url: '',
        __typename: 'Image'
      }
    ],
    __typename: 'FigureVersion'
  }
}
